var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFDBB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1883 8.26172L17.1484 6.22176C17.0517 6.12599 16.9211 6.07227 16.785 6.07227C16.6489 6.07227 16.5183 6.12599 16.4216 6.22176L10.3018 12.3416C10.207 12.4388 10.1544 12.5693 10.1551 12.705V14.745C10.1551 14.8802 10.2089 15.0099 10.3045 15.1056C10.4002 15.2012 10.5299 15.255 10.6651 15.255H12.7051C12.8408 15.2557 12.9713 15.2031 13.0685 15.1083L19.1883 8.98845C19.2841 8.89176 19.3378 8.76118 19.3378 8.62509C19.3378 8.489 19.2841 8.35841 19.1883 8.26172V8.26172ZM12.4947 14.235H11.1751V12.9154L15.255 8.83546L16.5746 10.1551L12.4947 14.235ZM17.295 9.4347L15.9754 8.1151L16.785 7.30549L18.1046 8.62509L17.295 9.4347ZM18.825 12.195V17.8049C18.825 18.0754 18.7175 18.3349 18.5262 18.5261C18.3349 18.7174 18.0755 18.8249 17.805 18.8249H7.60519C7.33467 18.8249 7.07523 18.7174 6.88395 18.5261C6.69267 18.3349 6.58521 18.0754 6.58521 17.8049V7.60511C6.58521 7.33459 6.69267 7.07515 6.88395 6.88387C7.07523 6.69259 7.33467 6.58512 7.60519 6.58512H13.2151C13.3503 6.58512 13.4801 6.63886 13.5757 6.7345C13.6713 6.83014 13.7251 6.95986 13.7251 7.09512C13.7251 7.23037 13.6713 7.36009 13.5757 7.45573C13.4801 7.55137 13.3503 7.60511 13.2151 7.60511H7.60519V17.8049H17.805V12.195C17.805 12.0598 17.8587 11.93 17.9544 11.8344C18.05 11.7388 18.1797 11.685 18.315 11.685C18.4502 11.685 18.58 11.7388 18.6756 11.8344C18.7712 11.93 18.825 12.0598 18.825 12.195V12.195Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/iconComment.6f989b1a30bb596ce0827a4dd515efda.svg";
export { ForwardRef as ReactComponent };